<template>
   <div id="data-list-list-view" class="data-list-container">
    <vx-card class="mb-5">
        <div class="vx-row" >
            <div class="vx-col lg:w-1/4 w-full">
               <p>Day</p>
                <datepicker :format="format"  v-model="search.date" class="w-full" name="day" @closed="getCourseClassByDay">
                    </datepicker>    
            </div>
            <div class="vx-col lg:w-1/4 w-full">
            <p>{{$t('TrainingOrderNumber')}}</p>
              <v-select
                label="DisplayName"
                v-model="search.CourseClassID"
                :options="courseClass" 
                :reduce="CourseClass => CourseClass.ID"
                @input="getSessionByCourseClassAndDate"
                ref="CourseClass"
              />
            </div>
           
         
            <div class="vx-col lg:w-1/4 w-full">
              <p>{{$t('Session')}}</p>
              <v-select
              style="width:180px"
                label="DateInLine"
                v-model="search.SessionID"
                :options="sessions" 
                :reduce="Session => Session.ID"
                ref="Session"
              />
            </div>
         
            <vs-button  class="mt-5" style="max-height: 40px;"  @click="loadTrainee" :disabled="!isFormValid">{{$t('LoadTrainee')}}</vs-button>
       </div>
    </vx-card>
    <vx-card class="p-5" v-if="trainee.length>0">
     <vs-table ref="table"   class="mr-5 ml-5" pagination :max-items="10"  :data="trainee">
        <template slot="thead">
          <vs-th sort-key="Trainee">{{$t('Trainee')}}</vs-th>
          <vs-th v-show="$acl.check('admin' || 'trainee')" sort-key="Attended">{{$t('IsAttended')}}</vs-th>
          <vs-th  v-show="$acl.check('admin' || 'instructor')" sort-key="Instructor">{{$t('InstructorConfirm')}} </vs-th>
        <vs-th  v-show="currentRule=='trainingcoordinator'||currentRule=='admin'" sort-key="Coordinator">{{$t('CoordinatorConfirm')}}</vs-th>
        </template>
        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.Trainee.FullName }}</p>
              </vs-td>
               <vs-td v-show="$acl.check('admin' || 'trainee')">
                   <vs-checkbox color="success" v-model="tr.IsAttended">{{$t('IsAttended')}}</vs-checkbox>
              </vs-td>
              <vs-td v-show="$acl.check('admin' || 'instructor')">
                   <vs-checkbox color="red" v-model="tr.IsInstructorConfirm">{{$t('InstructorConfirm')}} </vs-checkbox>
              </vs-td>
             
               <vs-td  v-show="currentRule=='trainingcoordinator' || currentRule=='admin'"> 
                   <vs-checkbox color="rgb(38, 187, 174)"  v-model="tr.IsCoordinatorConfirm">{{$t('CoordinatorConfirm')}}</vs-checkbox>
              </vs-td>
            
            </vs-tr>
          </tbody>
        </template>
    </vs-table>

        <vs-table ref="table2"   class="mr-5 ml-5"  :max-items="10"  :data="instructors">
            <template slot="thead">
              <vs-th sort-key="instructor">instructor</vs-th>
              <vs-th v-show="$acl.check('admin' )|| $acl.check('trainingcoordinator')" sort-key="Attended">{{$t('IsAttended')}}</vs-th>
            </template>
            <template slot-scope="{data}">
              <tbody>
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>
                    <p class="product-name font-medium truncate">{{ tr.Instructor.Name }}</p>
                  </vs-td>
                  <vs-td v-show="$acl.check('admin' )|| $acl.check('trainingcoordinator')">
                      <vs-checkbox color="success" v-model="tr.IsAttended">{{$t('IsAttended')}}</vs-checkbox>
                  </vs-td>
                </vs-tr>
              </tbody>
            </template>
        </vs-table>

    <div class="flex flex-wrap items-end p-6" slot="footer">
    
      <vs-button class="mr-6" @click="submitData" >{{$t('Submit')}}</vs-button>
      <vs-button type="border" color="danger" @click="initValues">{{$t('Cancel')}}</vs-button>
    </div>
    </vx-card>
   </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker';
import moduleCourseClass from "@/store/courseClass/moduleCourseClass.js";
import moduleTraineeAttendance from "@/store/traineeAttendance/moduleTraineeAttendance.js";
import vSelect from 'vue-select';
export default {
    components:{
        Datepicker,
        vSelect
    },
    data(){
        return{
              format:"dd-MM-yyyy",
            search:{},
            currentRule:null,
        }
    },
    computed:{
        isFormValid()
        {
          debugger
             return this.search.date&&this.search.CourseClassID!=undefined &&this.search.SessionID!=undefined;
        },
        courseClass(){
            return  this.$store.state.courseClassList.courseClass;
        },
        sessions()
        {
          return this.$store.state.courseClassList.courseClassSessions;
        },
        trainee(){
            return this.$store.state.traineeAttendanceList.traineeAttendance;
        },
        instructors(){
            return this.$store.state.traineeAttendanceList.instructorAttendance;
        }
    },
    methods:{
        initValues()
        {
            this.search.date=""; 
            this.search.CourseClassID="";
            this.search.SessionID="";
            this.$store.commit("traineeAttendanceList/SET_TraineeAttendance",[]);
        },
        submitData()
        {
            var vm=this;
            var trainees=this.$store.state.traineeAttendanceList.traineeAttendance.map(function(val){
                 val.TraineeID=val.Trainee.ID;
                 val.Trainee=null;
                val.CourseClassSessionID= vm.search.SessionID;
                val.IsAttended=val.IsCoordinatorConfirm
                return val;
            });

             var instructors=this.$store.state.traineeAttendanceList.instructorAttendance.map(function(val){
                 val.InstructorID=val.Instructor.ID;
                 val.Instructor=null;
                val.CourseClassSessionID= vm.search.SessionID;
                return val;
            });
             this.$store.dispatch("traineeAttendanceList/SaveTraineeAttendance",
                 trainees
             ).then(()=>{
                   this.initValues();
             });
              this.$store.dispatch("traineeAttendanceList/SaveInstructorAttendance",
                 instructors
             ).then(()=>{
                   this.initValues();
             });
        },
        loadTrainee()
        {
          debugger
            var data={};
            data.sessionID=this.search.SessionID;
            data.courseClassID=this.search.CourseClassID;
            this.$store.dispatch("traineeAttendanceList/GetTraineeAttendanceBySession",data);
            this.$store.dispatch("traineeAttendanceList/GetInstructorAttendanceBySession",data);
        },
        getCourseClassByDay()
        {
            if(this.search.date!=undefined)
            {
               this.$refs.CourseClass.clearSelection(); 
               this.$refs.Session.clearSelection(); 
               //this.search.SessionID = undefined;
               this.$store.commit('courseClassList/SET_CourseClass', []);
               this.$store.commit('courseClassList/SET_courseClassSession', []);

               this.$store.dispatch("courseClassList/GetCourseClassByDate",this.formatJsDate(this.search.date));
            }
        },
        getSessionByCourseClassAndDate()
        {
          debugger
            var data={};
              this.$refs.Session.clearSelection(); 
             this.$store.commit('courseClassList/SET_courseClassSession', []);
            data.date=this.formatJsDate(this.search.date);
            data.courseClassID=this.search.CourseClassID;
                     
            this.$store.dispatch("courseClassList/GetSessionByCourseClassIDAndDate",data);
        },
        formatJsDate(dateToFormat)
        {
            return dateToFormat.getFullYear()+"-"+ (dateToFormat.getMonth()+1)+"-"+dateToFormat.getDate();
        },
    },
    created()
    {
       if (!moduleCourseClass.isRegistered) {
          this.$store.registerModule("courseClassList", moduleCourseClass);
         moduleCourseClass.isRegistered = true;
       }
       
      if (!moduleTraineeAttendance.isRegistered) {
          this.$store.registerModule("traineeAttendanceList", moduleTraineeAttendance);
         moduleTraineeAttendance.isRegistered = true;
       }
       debugger;
   this.currentRule =JSON.parse(localStorage.getItem("userInfo")).userRole;
       
    }
}
</script>


<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>

<style>
  .vdp-datepicker__calendar
  {
    z-index: 429!important;
  }
</style>